import React, { useEffect, useState } from "react";
import AppContent from "../components/AppContent/AppContent";
import Navbar from "components/Navbar/Navbar";
import { useIdleTimer } from "react-idle-timer";
import { postLogout } from "service/api";
import { useAuthStore } from "store/auth";
import UseToast from "utils/AfToast";
import { useNavigate } from "react-router-dom";
import { CommandRelayProvider, CommandSenderPanel } from "components/CommandRelay";
import CommandToastContainer from "components/CommandRelay/CommandToastContainer";

export function DefaultLayout() {
  const [state, setState] = useState("Active");
  const [remaining, setRemaining] = useState(0);
  const [count, setCount] = useState(0);

  const { setToken, setUser, token, removeAll } = useAuthStore();
  const navigate = useNavigate();

  // Idle timeout duration (15 minutes in milliseconds)
  const IDLE_TIMEOUT = 1000 * 60 * 15;

  // Update last activity timestamp in localStorage (only in leader tab)
  const updateLastActivity = () => {
    if (isLeader()) {
      localStorage.setItem("lastActivity", Date.now().toString());
    }
  };

  // Check if user has been idle too long
  const checkIdleOnLoad = () => {
    const lastActivity = localStorage.getItem("lastActivity");
    if (lastActivity && token) {
      const timeElapsed = Date.now() - parseInt(lastActivity, 10);
      if (timeElapsed >= IDLE_TIMEOUT) {
        handleLogout();
      }
    }
  };

  // Logout function
  const handleLogout = () => {
    postLogout({ data: {}, headers: { Authorization: "Bearer " + token } })
      .then((res) => {
        UseToast("Logout Due to Inactivity", "warning");
        localStorage.removeItem("af_token");
        localStorage.removeItem("lastActivity");
        removeAll();
        navigate("/login");
      })
      .catch((err) => {
        console.error(err);
        UseToast("Logout Failed! Try Again", "error");
      });
  };

  const onIdle = () => {
    setState("Idle - Do Logout");
    handleLogout();
  };

  const onActive = () => {
    setState("Active");
  };

  const onMessage = () => {
    setCount(count + 1);
  };

  const { getRemainingTime, isLeader } = useIdleTimer({
    onIdle,
    onActive,
    onMessage,
    timeout: IDLE_TIMEOUT,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
  });

  // Initialize and periodic updates
  useEffect(() => {
    // Check idle status on component mount
    checkIdleOnLoad();

    // Set initial last activity timestamp if none exists
    if (!localStorage.getItem("lastActivity") && token) {
      updateLastActivity();
    }

    // Update last activity every minute in the leader tab
    const activityInterval = setInterval(() => {
      if (isLeader() && state === "Active") {
        updateLastActivity();
      }
    }, 1000 * 60); // Update every 1 minute

    // Update remaining time every 500ms for UI
    const remainingInterval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(activityInterval);
      clearInterval(remainingInterval);
    };
  }, [state, isLeader]);

  return (
    <CommandRelayProvider>
      <section>
        <div className="relative min-h-screen flex flex-col">
          <Navbar />
          <div className="flex-1 flex flex-col">
            <AppContent />
            <div className="bg-background_grey height-class"></div>
          </div>
        </div>
        <CommandSenderPanel />
        <CommandToastContainer />
      </section>
    </CommandRelayProvider>
  );
}